/* DaSHEa creator program page */
(function(){
  var root = window.document.querySelector('.dhc');
  if(!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  // Keep the creator animations separate from the shared header, cart and footer.
  var document = {
    querySelector: function(selector){ return root.querySelector(selector); },
    querySelectorAll: function(selector){ return root.querySelectorAll(selector); },
    getElementById: function(id){ return root.querySelector('#' + id); }
  };
  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fmt = function(n){ return Math.round(n).toLocaleString('cs-CZ'); };

  var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } }); },{threshold:.12});
  document.querySelectorAll('.rv').forEach(function(el){ io.observe(el); });

  var vio = new IntersectionObserver(function(es){
    es.forEach(function(e){ var v = e.target; if(e.isIntersecting && !RM){ v.preload = 'auto'; v.play().catch(function(){}); } else v.pause(); });
  },{threshold:.35});
  document.querySelectorAll('.hero video, .formats video').forEach(function(v){ vio.observe(v); });

  /* story: pinned scroll scene */
  var st = document.querySelector('.story'), vids = [].slice.call(st.querySelectorAll('video')), caps = [].slice.call(st.querySelectorAll('.cap')),
      dots = [].slice.call(st.querySelectorAll('.dots button')), bars = [].slice.call(st.querySelectorAll('.bar i')), chip = document.getElementById('chip'), N = caps.length, cur = -1, inView = false;
  function setStep(i){
    if(i === cur) return; cur = i;
    caps.forEach(function(c,k){ c.classList.toggle('on', k === i); c.setAttribute('aria-hidden', k !== i); });
    dots.forEach(function(d,k){ d.classList.toggle('on', k === i); d.classList.toggle('done', k < i); d.setAttribute('aria-current', k === i ? 'step' : 'false'); });
    bars.forEach(function(b,k){ b.classList.toggle('done', k < i); b.classList.toggle('on', k === i); });
    chip.textContent = 'Krok ' + (i + 1) + ' ze ' + N;
    vids.forEach(function(v,k){
      var on = k === i;
      v.classList.toggle('on', on);
      if(on){ v.preload = 'auto'; if(!RM && inView) v.play().catch(function(){}); } else v.pause();
      if(k === i + 1 && v.preload === 'none') v.preload = 'metadata';
    });
  }
  function story(){
    var r = st.getBoundingClientRect(), total = r.height - innerHeight;
    var p = Math.min(Math.max(-r.top / total, 0), .9999), i = Math.floor(p * N);
    inView = r.top < innerHeight && r.bottom > 0;
    setStep(i);
    if(bars[i]) bars[i].style.setProperty('--p', Math.round((p * N - i) * 100) + '%');
    if(!inView) vids.forEach(function(v){ v.pause(); });
    else if(vids[cur].paused && !RM) vids[cur].play().catch(function(){});
  }
  dots.forEach(function(d){
    d.addEventListener('click', function(){
      var total = st.offsetHeight - innerHeight;
      scrollTo({top: st.getBoundingClientRect().top + scrollY + total * (+d.dataset.go + .5) / N, behavior: RM ? 'auto' : 'smooth'});
    });
  });

  var mcta = document.getElementById('mcta'), apply = document.getElementById('prihlaska');
  function onScroll(){
    var y = scrollY;
    var sr = st.getBoundingClientRect();
    mcta.classList.toggle('show', y > innerHeight * .9 && apply.getBoundingClientRect().top > innerHeight * .6 && (sr.bottom < innerHeight * .5 || sr.top > innerHeight * .5));
    story();
  }
  addEventListener('scroll', onScroll, {passive:true});
  addEventListener('resize', story);
  onScroll();

  function fill(r){ r.style.setProperty('--f', ((r.value - r.min) / (r.max - r.min) * 100) + '%'); }
  function seg(el, cb){
    el.addEventListener('click', function(e){
      var b = e.target.closest('button'); if(!b) return;
      el.querySelectorAll('button').forEach(function(x){ x.classList.remove('on'); });
      b.classList.add('on'); cb(b);
    });
  }

  /* calculator A: 20 % of orders via own code, avg order ~950 Kč */
  var aOrd = document.getElementById('aOrd'), aSc = [].slice.call(document.querySelectorAll('#aScale span'));
  function calcA(){
    var o = +aOrd.value;
    document.getElementById('aOrdOut').textContent = o;
    document.getElementById('aRes').textContent = fmt(Math.round(o * 950 * .2 / 10) * 10) + ' Kč';
    var band = o < 10 ? 0 : o < 20 ? 1 : 2;
    aSc.forEach(function(x,k){ x.classList.toggle('on', k === band); });
    fill(aOrd);
  }
  aOrd.addEventListener('input', calcA); calcA();

  /* calculator B: ad bonus 3–5 % of spend; ~550 Kč per 1 000 views (conservative beauty CPM) */
  var bSpend = document.getElementById('bSpend');
  function calcB(){
    var s = +bSpend.value;
    document.getElementById('bSpendOut').textContent = fmt(s) + ' Kč';
    document.getElementById('bRes').textContent = fmt(s * .03) + '–' + fmt(s * .05) + ' Kč';
    document.getElementById('bImp').textContent = 'video uvidí zhruba ' + fmt(Math.round(s / 550 * 1000 / 1000) * 1000) + '×';
    fill(bSpend);
  }
  bSpend.addEventListener('input', calcB); calcB();

  /* levels light up one after another */
  var lvs = [].slice.call(document.querySelectorAll('.lv'));
  var lio = new IntersectionObserver(function(es){
    if(!es.some(function(e){ return e.isIntersecting; })) return;
    lvs.forEach(function(l,k){ setTimeout(function(){ l.classList.add('lit'); }, RM ? 0 : 200 + k * 500); });
    lio.disconnect();
  },{threshold:.25});
  lio.observe(document.getElementById('levels'));

  /* chat messages arrive one by one */
  var msgs = [].slice.call(document.querySelectorAll('.msg'));
  var mio = new IntersectionObserver(function(es){
    if(!es.some(function(e){ return e.isIntersecting; })) return;
    msgs.forEach(function(m,k){ setTimeout(function(){ m.classList.add('in'); }, RM ? 0 : 300 + k * 750); });
    mio.disconnect();
  },{threshold:.3});
  mio.observe(document.getElementById('msgs'));

  /* Shopify contact form: leave submission, spam protection and success to Shopify. */
  var f = document.getElementById('dhc-form'); if(!f || !f.querySelector('.fields')) return;
  f.addEventListener('submit', function(ev){
    var req = [].slice.call(f.querySelectorAll('[required]'));
    req.forEach(function(i){ i.classList.remove('err'); });
    var bad = req.filter(function(i){ return i.type === 'checkbox' ? !i.checked : !i.value.trim(); });
    if(bad.length){ ev.preventDefault(); bad.forEach(function(i){ i.classList.add('err'); }); bad[0].focus(); return; }
  });
})();
